import { IInput, ItemTypes } from '../interfaces';
import { generateProps, generateRules } from './generate';

import { SimpleItem } from 'devextreme-react/form';
import { defaultIInputs } from '../defaults';

const InputChoice = (input: IInput) => {
    return (
        <SimpleItem {...generateProps(input, defaultIInputs[ItemTypes.Choice])}>
            {generateRules(input, defaultIInputs[ItemTypes.Choice])}
        </SimpleItem>
    );
};

export default InputChoice;
